import { css } from '@linaria/core';

const wrapper = css`
  background-color: #fef8e6;
  padding: 20px;
  margin: 40px -20px 0 -20px;

  p {
    color: #1a1a1a;
    font-size: 18px;

    &:first-child {
      margin-top: 0;
    }

    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0 0 30px 20px;

    li {
      position: relative;
      padding-left: 25px;
      margin-bottom: 20px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 5px;
        height: 5px;
        background-color: #1a1a1a;
      }
    }
  }

  a {
    color: #1a1a1a;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;

    &:hover {
      color: #1a1a1a;
      text-decoration-thickness: 2px;
      text-underline-offset: 2px;
    }
  }

  @media (min-width: 1080px) {
    padding: 40px;
  }
`;

export default function HelpFooter() {
  const rootElement = document.getElementById('root');
  const helpText = rootElement?.getAttribute('data-search-helptext') || '';

  if (helpText.length === 0) {
    return null;
  }

  return (
    <div className={wrapper} dangerouslySetInnerHTML={{ __html: helpText }} />
  );
}
